export enum EmployeeTabKey {
  GENERAL_INFORMATION = 'GENERAL_INFORMATION',
  ADDRESS = 'ADDRESS',
  BANK_INFORMATION = 'BANK_INFORMATION',
  EMPLOYMENT = 'EMPLOYMENT',
  SETTINGS_GENERAL = 'SETTINGS_GENERAL',
  SETTINGS_HOLIDAY_PAY = 'SETTINGS_HOLIDAY_PAY',
  SETTINGS_EXPENSE = 'SETTINGS_EXPENSE',
  SETTINGS_OTHERS = 'SETTINGS_OTHERS',
  DOCUMENTS_ONBOARDING = 'DOCUMENTS_ONBOARDING',
  DOCUMENTS_OTHER = 'DOCUMENTS_OTHER',
  NOTE_LISTING = 'NOTE_LISTING',
  PAYMENTS = 'PAYMENTS',
  DEDUCTIONS = 'DEDUCTIONS',
  ASSIGNMENT = 'ASSIGNMENT',
  TIMESHEET = 'TIMESHEET',
  PAYSLIP = 'PAYSLIP',
  BACK_OFFICE = 'BACK_OFFICE',
  ATTACHMENT_ORDER = 'ATTACHMENT_ORDER',
  PENSION = 'PENSION',
  EXPENSE = 'EXPENSE',
  BIK = 'BIK',
  MESSAGE_HISTORY = 'MESSAGE_HISTORY',
  ACTIVITY_LOG = 'ACTIVITY_LOG',
  YTD_HISTORY = 'YTD_HISTORY',
  EMPLOYMENT_HISTORY = 'EMPLOYMENT_HISTORY',
  EMAIL_LOG = 'EMAIL_LOG',
  RPN_UPDATE = 'RPN_UPDATE',
}
